import { parse, parseISO, format, isDate } from "date-fns"

const currencyFormat = new Intl.NumberFormat("en-US", {
  style: "currency", currency: "USD",
  currencyDisplay: 'narrowSymbol',
  maximumFractionDigits: 2,
  minimumFractionDigits: 2
})
const currencyPlainFormat = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2
})

export const FORMAT_TYPE = {
  currency: 'currency',
  datetime: 'datetime',
  date: 'date'
}
const defaults = {
  datetime: {
    in: 'M/d/yyyy h:mm:ss a',
    out: 'MMM dd, yyyy hh:mm:ss a'
  },
  date: {
    in: 'MM-dd-yyyy',
    out: 'MMM dd, yyyy'
  }
}
export const formatText = (text, type, formatDef) => {
  if (typeof type === 'function')
    return type(text, formatDef)
  const checkType = type?.trim().toLowerCase()
  switch (checkType) {
    case FORMAT_TYPE.currency:
      let basic = isNaN(text) ? 0 : Number(text || 0).toFixed(2)

      switch (formatDef) {
        case 'no-symbol':
          return currencyPlainFormat.format(basic)
        default:
          return currencyFormat.format(basic)
      }
    case FORMAT_TYPE.date:
    case FORMAT_TYPE.datetime:
      if (!text)
        return ''
      let dateFormat = defaults[checkType]
      if (!!formatDef) {
        if (typeof formatDef === 'string')
          dateFormat.in = formatDef
        else
          dateFormat = { ...dateFormat, ...formatDef }
      }
        
      let parsed
		if (isDate(text)) {
		  parsed = text
		} else if (typeof text === 'string' && text.includes('T')) {
		  // Handle ISO 8601 format
		  parsed = parseISO(text)
		} else {
		  parsed = parse(text, dateFormat.in, new Date())
		}

      if (formatDef?.out === 'raw')
        return parsed

      return format(parsed, dateFormat.out)
    default:
      return text || ''
  }
}

export { defaults as DEFAULT_FORMATS }

export const generateMonthOptions = (dateFormat = 'MMMM', zeroIndexed) => {
  const base = new Date()
  const ret = []

  for (let i = 0; i < 12; i++) {
    base.setMonth(i)
    ret.push({
      value: (zeroIndexed ? i : i + 1).toString().padStart(2, '0'),
      description: format(base, dateFormat)
    })
  }

  return ret
}